import { BaseEntity } from './base-entity';

/**
 * Role Interface
 */
export interface Role extends BaseEntity {
  name: string;
  key?: string;
  accessList: Access;
}

export interface Access {
  read: boolean;
  edit: boolean;
  add: boolean;
  lock: boolean;
  unlock: boolean;
  publish: boolean;
  import: boolean;
  export: boolean;
  remove: boolean;
}

export interface RoleAccessKey {
  key: keyof Access; // Ensure curr.key is one of the keys in ToolAccess
  name: string;
}

export function mergeAccessList(accessList: Access[]): Access {
  return accessList.reduce(
    (mergedAccess, currentAccess) => ({
      read: mergedAccess.read || currentAccess.read,
      edit: mergedAccess.edit || currentAccess.edit,
      add: mergedAccess.add || currentAccess.add,
      lock: mergedAccess.lock || currentAccess.lock,
      unlock: mergedAccess.unlock || currentAccess.unlock,
      publish: mergedAccess.publish || currentAccess.publish,
      import: mergedAccess.import || currentAccess.import,
      export: mergedAccess.export || currentAccess.export,
      remove: mergedAccess.remove || currentAccess.remove,
    }),
    {
      read: false,
      edit: false,
      add: false,
      lock: false,
      unlock: false,
      publish: false,
      import: false,
      export: false,
      remove: false,
    } as Access // Default object with all permissions set to false
  );
}

export const accessList: RoleAccessKey[] = [
  { name: 'lesen (Mindestzugriff)', key: 'read' },
  { name: 'bearbeiten', key: 'edit' },
  { name: 'hinzufügen', key: 'add' },
  { name: 'sperren', key: 'lock' },
  { name: 'freigeben', key: 'unlock' },
  { name: 'veröffentlichen', key: 'publish' },
  { name: 'importieren', key: 'import' },
  { name: 'exportieren', key: 'export' },
  { name: 'löschen', key: 'remove' },
];

export const roleTemplates: Role[] = [
  {
    _id: '',
    icon: 'fas fa-glasses',
    key: 'reader',
    sub: 'Grundrolle, nur lesender Zugriff auf zugewiesene Arbeitsbereiche.',
    name: 'Leser:in',
    accessList: {
      read: true,
      edit: false,
      add: false,
      lock: false,
      unlock: false,
      publish: false,
      import: false,
      export: false,
      remove: false,
    },
  },
  {
    _id: '',
    icon: 'fas fa-marker',
    key: 'editor',
    name: 'Editor:in',
    sub: 'Bearbeiter-Rolle. Zugewiesene Arbeitsbereiche können sowohl hinzufügen, bearbeiten als auch Import/Export.',
    accessList: {
      read: true,
      edit: true,
      add: true,
      lock: false,
      unlock: false,
      publish: false,
      import: true,
      export: true,
      remove: true,
    },
  },
  {
    _id: '',
    icon: 'fas fa-earth-europe',
    key: 'publisher',
    name: 'Publisher:in',
    sub: 'Veröffentlichen und sperre. Arbeitsbereiche mit dieser Rolle können nicht bearbeiten oder hinzufügen, sonder sind rein für die Veröffentlichung zuständig.',
    accessList: {
      read: true,
      edit: false,
      add: false,
      lock: true,
      unlock: true,
      publish: true,
      import: false,
      export: false,
      remove: false,
    },
  },
  {
    _id: '',
    key: 'admin',
    icon: 'fas fa-toolbox',
    name: 'Alleskönner:in',
    sub: 'Arbeitsbereiche mit dieser Rolle können alle Funktionen durchführen.',
    accessList: {
      read: true,
      edit: true,
      add: true,
      lock: true,
      unlock: true,
      publish: true,
      import: true,
      export: true,
      remove: true,
    },
  },
];
